export enum ErrorPageTypes {
    NOT_FOUND = '404',
    INTERNAL_SERVER_ERROR = '500',
    MAINTENANCE = 'maintenance',
}
